import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  Esri4MapComponent,
  Esri4MapService,
  CustomWidgetDirective,
  LayersToggleComponent
} from './lib/index';

export * from './lib/esri4-map/esri4-map.component';


export class Angular2Esri4Module { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule
  ],
  declarations: [
    Esri4MapComponent,
    CustomWidgetDirective,
    LayersToggleComponent
  ],
  exports: [
    Esri4MapComponent,
    CustomWidgetDirective,
    LayersToggleComponent
  ],
  providers: [
    Esri4MapService
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
